<template>
  <div class="" style="max-height: 150px">
    <v-row>
      <v-col cols="12" class="text__col px-3">
        <label class="field-labels">Trade Privacy</label>
        <div>
          <v-radio-group v-model="tradePrivacy" row class="py-0">
            <v-radio
              v-for="(item, i) in radioBtn"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></v-radio>
          </v-radio-group>
        </div>
      </v-col>
      <!-- <v-col cols="4" sm="4" md="4" class="text__col">
        <label
          ><span :class="switchValue ? '' : labelClass">Public</span> |
          <span :class="switchValue ? labelClass : ''">Group</span></label
        >
        <div class="pl-2 mt-2">
          
          <label class="toggle">
            <input
              :class="
                flag ? 'toggle-checkbox toggle-checkbox1' : 'toggle-checkbox'
              "
              type="checkbox"
              v-model="switchValue"
            />
            <div
              :class="flag ? 'toggle-switch toggle-switch1' : 'toggle-switch'"
            ></div>
          </label>
        </div>
      </v-col> -->
      <v-col cols="12" class="text__col px-3" v-if="value.postTo == 'group'">
        <label class="field-labels"> Group <span class="label">*</span></label>
        <v-select
          :disabled="value.postTo !== 'group'"
          :items="ownGroups"
          item-text="name"
          item-value="id"
          :loading="ownGroups.length === 0 && loading"
          outlined
          class="pb-6"
          :value="value.groupId"
          @change="onGroupSelect"
        ></v-select>
      </v-col>
    </v-row>
    <!-- <div>
      <h3>Post this trade to:</h3>
      <v-radio-group :value="value.postTo" @change="onPostToChange" row>
        <v-radio label="Public" value="followers"></v-radio>
        <v-radio label="Group" value="group"></v-radio>
      </v-radio-group>
    </div>
    <div class="d-flex flex-column justify-space-between">
      <div class="d-none d-md-block">Group</div>
      <v-select
        :disabled="value.postTo !== 'group'"
        :items="ownGroups"
        item-text="name"
        item-value="id"
        label="Select Group"
        :loading="ownGroups.length === 0 && loading"
        outlined
        :value="value.groupId"
        @change="onGroupSelect"
      ></v-select>
    </div> -->
    <!-- <br /><br /> -->
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, required: true },
    flag: { type: Boolean, required: true },
    groupId: { type: String, default: null },
    isPrivate: { type: String, required: true },
  },

  data: () => ({
    loading: false,
    switchValue: false,
    tradePrivacy: "public",
    radioBtn: [
      {
        label: "Public",
        value: "public",
      },
      {
        label: "Private (Only me)",
        value: "private",
      },
      {
        label: "Group",
        value: "group",
      },
    ],
  }),

  async created() {
    this.loading = true;
    await this.$store.dispatch("groups/fetchOwnGroups");
    this.loading = false;
  },

  computed: {
    ownGroups() {
      return this.$store.state.groups.ownGroups;
    },
    labelClass() {
      if (this.flag) {
        return "sellStatusClass";
      } else {
        return "buyStatusClass";
      }
    },
    group_id() {
      return this.$store.state.tradeData.showModal.groupId;
    },
  },
  watch: {
    group_id(value) {
      if (value) {
        this.switchValue = true;
        setTimeout(() => {
          this.onGroupSelect(parseInt(this.groupId));
        }, 200);
      }
    },
    switchValue(value) {
      console.log(value, "switch value");
      if (value) {
        this.onPostToChange((this.value.postTo = "group"));
      } else {
        this.onPostToChange((this.value.postTo = "followers"));
      }
    },
    tradePrivacy(value) {
      this.onPostToChange((this.value.postTo = value));
    },
  },

  methods: {
    onPostToChange(v) {
      this.$emit("input", { postTo: v, groupId: null });
    },

    onGroupSelect(v) {
      this.$emit("input", { postTo: this.value.postTo, groupId: v });
    },
  },
  mounted() {
    if (this.groupId) {
      this.switchValue = true;
      this.tradePrivacy = "group";
      setTimeout(() => {
        this.onGroupSelect(parseInt(this.groupId));
      }, 200);
    }
    if (this.isPrivate == "private") {
      this.tradePrivacy = "private";
    }
  },
};
</script>
<style scoped>
.buyStatusClass {
  color: #2d8cff;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 13px;
  line-height: 18px;
}
.label {
  color: red;
}
.sellStatusClass {
  color: red;

  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 13px;
  line-height: 18px;
}
/* raw switch*/
*,
*:before,
*:after {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, ".SFNSText-Regular", "Helvetica Neue", "Roboto",
    "Segoe UI", sans-serif;
}

.toggle {
  cursor: pointer;
  display: inline-block;
}

.toggle-switch {
  display: inline-block;
  background: #2d8cff;
  border-radius: 16px;
  width: 55px;
  height: 31px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;
}
.toggle-switch1 {
  display: inline-block;
  background: #eb5757;
  border-radius: 16px;
  width: 55px;
  height: 31px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;
}
.toggle-switch:before,
.toggle-switch:after {
  content: "";
}
.toggle-switch:before {
  display: block;
  background: linear-gradient(to bottom, #fff 0%, #eee 100%);
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
  width: 24px;
  height: 24px;
  position: absolute;
  top: 4px;
  left: 4px;
  transition: left 0.25s;
}
.toggle:hover .toggle-switch:before {
  background: linear-gradient(to bottom, #fff 0%, #fff 100%);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
.toggle-checkbox:checked + .toggle-switch {
  background: #2d8cff;
}
.toggle-checkbox1:checked + .toggle-switch1 {
  background: #eb5757;
}
.toggle-checkbox:checked + .toggle-switch:before {
  left: 30px;
}

.toggle-checkbox {
  position: absolute;
  visibility: hidden;
}

.toggle-label {
  margin-left: 5px;
  position: relative;
  top: 2px;
}

.field-labels {
  font-family: Avenir;
  font-size: 13px;
  font-weight: 800 !important;
  line-height: 17.76px;
  text-align: left;
}
/* raw switch*/
</style>
